import React from "react";
import NavBar from "../../nav/nav-bar";
import Header from "../../header/header";
import Footer from "../../footer/footer";
import { useState } from "react";
import { useEffect } from "react";
import Service from "../../webservice/http";
import { debounce } from "lodash";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";
import config from "../../config";
import Pagination from "../../components/pagination";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { storage } from "../../utils/storage";

function AccessLog() {
  const [expandedRows, setExpandedRows] = useState({});
  const services = new Service();
  const history = useHistory();
  const [tabledata, setTabledata] = useState([]);
  const [search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);
  const [graphdata, setGraphdata] = useState([]);
  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const token = storage.getItem("access_token");

  async function Dashbaorddata() {
    setLoading(true);

    let url = `api/access_control/user_access_log/`;

    if (search) {
      url += url.includes("?") ? `&search=${search}` : `?search=${search}`;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const page = queryParams.get("page");

    if (page == null) {
      url += url.includes("?") ? `&page=1` : `?page=1`;
    } else {
      url += url.includes("?") ? `&page=${page}` : `?page=${page}`;
    }

    try {
      const res = await services.get(url);
      setTabledata(res?.data);
      setGraphdata(res);
      setLoading(false);

      setTotalpage(res?.pagination?.page_numbers);
      setTotalresult(res?.pagination?.total_results);
      // settMaxpage(res?.pagination?.total_pages);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  }

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    history.push(`/access-logs/?page=${pageNumber}`);
  };

  useEffect(() => {
    Dashbaorddata();
  }, [history, currentPage, search]);

  const graphData =
    graphdata?.dates?.map((date, index) => ({
      date,
      success: graphdata?.success[index],
      failed: -graphdata?.failed[index],
    })) || [];

  const debouncedSearch = debounce((value) => {
    setSearch(value.toLowerCase());
  }, 500);

  const downloadReport = async () => {
    try {
      const response = await axios.get(
        search
          ? `${config.API_BASE_URL}/api/access_control/download_accesslog/?search=${search}`
          : `${config.API_BASE_URL}/api/access_control/download_accesslog/`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
            // Accept: "text/csv",
          },
        },
      );

      const blob = response.data;
      // console.log(
      //   "Response Data Type:",
      //   blob instanceof Blob ? "Blob" : typeof blob
      // );

      const contentType = response.headers["content-type"];
      if (!contentType.includes("text/csv")) {
        console.warn("Unexpected Content-Type:", contentType);
      }
      const url = URL.createObjectURL(blob);
      const contentDisposition = response.headers["content-disposition"];
      let filename = "access_log.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the report:", error);
      console.error("Error stack:", error.stack);
      alert(
        "Failed to download the report. Please check the after sometime or contact support.",
      );
    }
  };

  return (
    <div>
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid" style={{ background: "#EEF2F5" }}>
          <div className="my-call" style={{ background: "white" }}>
            <div className="call-table" style={{ marginBottom: "80px" }}>
              <div
                className="my-calls-column"
                style={{ padding: "15px 0px 0px 15px" }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="pannel-heading clearfix">
                        <div className="pannel-heading-icon">
                          <i class="fa fa-cog" aria-hidden="true"></i>
                        </div>
                        <div className="pannel-heading-info">
                          <h3>Access Log</h3>
                          <p> Details</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {Loading ? (
                <div
                  className=" flex justify-center items-center"
                  style={{ border: "1px solid lightgray", height: "300px" }}
                >
                  <ClipLoader color="#2056FF" size="50px" />
                </div>
              ) : (
                <div className="w-full h-96">
                  <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={graphData}>
                      <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
                      <XAxis dataKey="date" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="success"
                        stroke="#FFA500"
                        name="Success"
                        strokeWidth={2}
                      />
                      <Line
                        type="monotone"
                        dataKey="failed"
                        stroke="#0000FF"
                        name="Failed"
                        strokeWidth={2}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              )}

              <div className=" flex justify-end  mr-10 items-center">
                {/* <div className="mr-6 inline-block rounded-lg border"> */}
                <input
                  onChange={(event) => debouncedSearch(event.target.value)}
                  type="text"
                  placeholder="Search by user "
                  className="search-tag"
                  style={{
                    // border: "1px solid transparent",
                    border: "none",
                    background: "#eef2f5",
                    borderRadius: "10px",
                    width: "250px",
                    outline: "none",
                    paddingLeft: "8px",
                    height: "35px",
                  }}
                />

                <div className=" flex justify-end my-6 ml-6">
                  <button
                    className={` text-white px-8 py-3 rounded-xl export-btn tracking-wide ${
                      !tabledata?.length ? "" : ""
                    }`}
                    // disabled={!tabledata?.length}
                    onClick={downloadReport}
                  >
                    Export
                  </button>
                </div>
              </div>
              {Loading ? (
                <div
                  className=" flex justify-center items-center"
                  style={{ border: "1px solid lightgray", height: "625px" }}
                >
                  <ClipLoader color="#2056FF" size="50px" />
                </div>
              ) : (
                <>
                  <div className="mx-auto mt-10 bg-white rounded-lg shadow-md p-4">
                    {/* Table Header */}
                    <div className="grid grid-cols-7 bg-gray-600 text-white font-semibold py-5 rounded-t-lg px-8">
                      <div className="px-4">Timestamp</div>
                      <div className="px-4">User</div>
                      <div className="px-4">IP Address</div>
                      <div className="px-4">Status Code</div>
                      <div className="px-4">HTTP Method</div>
                      <div className="px-4">Action</div>
                      <div className="px-4">Details</div>
                    </div>

                    {/* Table Body */}

                    {tabledata?.length === 0 ? (
                      <div
                        className="flex justify-center items-center h-96"
                        style={{ border: "1px solid lightgray" }}
                      >
                        <p className="text-gray-500">No access logs found.</p>
                      </div>
                    ) : (
                      // Table Rows
                      <div
                        className="divide-y divide-gray-200 overflow-y-auto px-8"
                        style={{ maxHeight: "625px" }}
                      >
                        {tabledata?.map((logs, index) => (
                          <div key={index}>
                            <div className="grid grid-cols-7 py-5 hover:bg-gray-50 items-center">
                              <div className="px-4 flex gap-3 items-center text-gray-800">
                                <span>{logs?.date}</span>
                                <span>{logs?.time}</span>
                              </div>
                              <div className="px-4 text-gray-800">{`${logs?.user[0].toUpperCase()}${logs?.user.slice(
                                1,
                              )}`}</div>
                              <div className="px-4 text-gray-800">
                                {logs?.ip_address}
                              </div>
                              <div className="px-4 text-gray-800">
                                {logs?.status_code}
                              </div>
                              <div className="px-4 text-gray-800">{`${logs.method[0].toUpperCase()}${logs.method.slice(
                                1,
                              )}`}</div>
                              <div className="px-4 text-gray-800 break-words">
                                {logs?.action}{" "}
                              </div>
                              <div className="px-4">
                                <div
                                  className="text-gray-800 cursor-pointer flex items-center gap-2"
                                  style={{
                                    border: "1px solid gray",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    width: "fit-content",
                                  }}
                                  onClick={() => toggleRow(index)}
                                >
                                  <button>Details</button>
                                  {expandedRows[index] ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="24px"
                                      viewBox="0 -960 960 960"
                                      width="24px"
                                      fill="#1f1f1f"
                                    >
                                      <path d="m280-400 200-200 200 200H280Z" />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="24px"
                                      viewBox="0 -960 960 960"
                                      width="24px"
                                      fill="#1f1f1f"
                                    >
                                      <path d="M480-360 280-560h400L480-360Z" />
                                    </svg>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Expanded Row Section */}
                            {expandedRows[index] && (
                              <div className="px-4 py-4 bg-gray-50 transition-all duration-300 ease-in-out">
                                <div className="flex gap-4">
                                  <div>
                                    <strong>Api Called:</strong>{" "}
                                    {logs?.api_called || "N/A"}
                                  </div>
                                  <div>
                                    <strong>Login Level:</strong>{" "}
                                    {logs?.level[0].toUpperCase() +
                                      logs?.level.slice(1) || "N/A"}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalpage?.length}
                    onPageChange={handlePageClick}
                    totalresult={totalresult}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AccessLog;
